export default "__VITE_ASSET__c1d95d5e__"